module.exports = __webpack_public_path__ + "img/company_address.c931b8b.webp";